var _defs, _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoodWhiteGradientCR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 207.36 89.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 68.73,
    y1: -656.84,
    x2: 122.48,
    y2: -656.84,
    gradientTransform: "translate(0 -611.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ff8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fa9f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f7b334"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.18,31.6c-.3-.4-.7-.9-1-1.3l-.3-.3c-.6-.7-1.3-1.4-2-2h0c-.3-.3-.7-.5-1.2-.5s-1,.2-1.3,.6h0l-3.7,5.2h0c-.2,.3-.3,.6-.3,1,0,.5,.2,.9,.5,1.2h0c.9,.8,1.6,1.7,2.2,2.7,1,1.7,1.7,3.6,1.9,5.6,0,.3,.1,.7,.1,1v.2c0,7.1-5.8,12.9-12.9,12.9h0c-4.2,0-8.1-2-10.5-5.4l-14.5-20.4c-4.2-5.9-11.1-9.4-18.3-9.5-12.4,0-22.4,10.1-22.4,22.5,0,.8,0,1.5,.1,2.2v.1c.1,.8,.2,1.5,.3,2.2v.1c1,4.7,3.4,8.9,7,12.1,.3,.4,.8,.6,1.3,.6,.7,0,1.2-.4,1.5-1h0l3.3-4.7c.2-.3,.4-.6,.4-1s-.2-.8-.5-1.2h0c-2.6-2.5-4.1-6-4-9.6-.1-3.4,1.2-6.6,3.6-9,5-5.1,13.2-5.2,18.3-.3,.6,.6,1.1,1.2,1.5,1.8l14.7,20.7c7.2,10.1,21.2,12.4,31.3,5.2s12.4-21.2,5.2-31.3c-.1-.1-.2-.2-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.48,24.4c0-.9-.7-1.7-1.6-1.7h-.1c-1.7-.2-3.4-.2-5.1-.1l-1,.1c-6.3,.7-12,4.1-15.7,9.3l-14.5,20.6c-2.2,3.4-6,5.5-10,5.6h-.1c-.5,0-.9,.3-1.2,.7h0l-.1,.1-4,5.6c-.6,.7-.4,1.8,.3,2.4,.2,.1,.3,.2,.5,.3h.1c2.2,.2,4.4,.3,6.6,.2,6.3-.7,12.1-4.1,15.8-9.3l14.4-20.4c2.3-3.1,5.8-5.1,9.7-5.4h.1c.6,0,1.2-.3,1.4-.9l4.2-6c.2-.4,.3-.7,.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.28,23.9h-5.4c-1.1,0-2,.9-2,2v1.5c0,.4-.3,.7-.7,.7-.2,0-.4-.1-.5-.2-3.6-3.2-8.2-4.9-12.9-4.9C10.28,23,.88,32.8,.88,45.7s9.2,22.4,21.9,22.4c5.9,0,11.3-2.4,14.2-6.3-.2,11.7-4.9,17.5-14.3,17.5-4.4,0-8.5-2.2-11-5.9-.5-.8-1.6-1.1-2.5-.7-1.3,.7-3.2,1.7-4.5,2.4-.5,.3-.9,.7-1,1.2s-.1,1,.2,1.4c4,6.5,11.2,10.5,18.8,10.4,15.6,0,23.5-9.4,23.5-28V25.9c0-1.1-.8-1.9-1.9-2ZM23.48,58.8c-7.6,0-13.1-5.4-13.1-13.2-.2-7.1,5.4-13.1,12.5-13.3h.6c6.4,0,13.4,4.2,13.4,13.3,0,8.6-6.9,13.2-13.4,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.08,1.1h-5.4c-1.1,0-2,.9-2,2V27c0,.4-.4,.8-.8,.8-.2,0-.4-.1-.5-.2-3.1-2.9-7.8-4.5-12.9-4.5-12.6,0-21.7,9.5-21.7,22.5s9.3,22.5,21.8,22.5c4.7,0,9.3-1.6,12.9-4.7,.3-.3,.8-.3,1.1,0,.1,.1,.2,.3,.2,.5v1.3c0,1.1,.9,2,2,2h5.4c1.1,0,2-.9,2-2V3.1c-.1-1.1-1-2-2.1-2h0Zm-7.5,44.3c0,9.2-6.9,13.4-13.3,13.4-7.4,0-13-5.8-13-13.4s5.5-13.1,13-13.1c6.6,0,13.3,4.5,13.3,13.1Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.81,5.61c0,2.48-1.97,4.49-4.45,4.49s-4.44-2.01-4.44-4.49,1.96-4.51,4.44-4.51,4.45,2.02,4.45,4.51Zm-.61,0c0-2.14-1.71-3.9-3.84-3.9s-3.84,1.76-3.84,3.9,1.69,3.88,3.84,3.88,3.84-1.74,3.84-3.88Zm-3.25,.65l1.11,1.62h-.71l-1.09-1.58h-.71v1.58h-.64V3.39h1.69c.99,0,1.43,.69,1.43,1.43s-.32,1.29-1.07,1.44Zm-1.41-2.27v1.72h1.03c.59,0,.83-.43,.83-.85s-.24-.87-.81-.87h-1.04Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodWhiteGradientCR);
export default __webpack_public_path__ + "static/media/good-white-gradient-cR.094eefef09c64c39ec68f30cdeac6ced.svg";
export { ForwardRef as ReactComponent };